import o from "./ghl-ui.es1438.js";
import t from "./ghl-ui.es1439.js";
import a from "./ghl-ui.es1440.js";
import r from "./ghl-ui.es1441.js";
import m from "./ghl-ui.es1442.js";
var e = {
  code: "da",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s = e;
export {
  s as default
};
